export default __webpack_public_path__ + "static/media/storm-3.c0dcf77e.png";